import { Component, input } from '@angular/core';
import { PrimaryGaragesInfo, VehicleInfo } from 'src/app/models/vehicle.model';

@Component({
  selector: 'app-detailed-vehicle-info-card',
  templateUrl: './detailed-vehicle-info-card.component.html',
  styleUrls: ['./detailed-vehicle-info-card.component.scss'],
  standalone: false,
})
export class DetailedVehicleInfoCardComponent {
  /* Detailed vehicle information displayed in the card */
  vehicleInfo = input<VehicleInfo>();

  /* List of primary garages associated with the vehicle */
  primarygaragesInfo = input<PrimaryGaragesInfo[]>([]);

  /* Indicates whether the component is rendered in mobile context */
  isMobileApp = input<boolean>(false);

}
